import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { FormGroup, Button, Col, Row, FormControl, ControlLabel} from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import moment from "moment";
import DatePicker from "react-datepicker";
import FixedCostsService from "../../../services/FixedCostsService";
import ProjectsService from "../../../services/ProjectsService";
import HandleError from "../../../services/HandleError";
import LoaderInline from "../../helpers/LoaderInline";
import InlineError from "../../messages/InlineError";
import { dataToSelectOption } from "../../helpers/HelperFunctions";

class FixedCostsCreateForm extends Component {

    state = {
    	isLoadingProjects: true,
    	saveFixedCostLoading: false,
    	formData:{
    		date: moment().format("YYYY-MM-DD")
    	},
    	errors: {}
    }

	componentDidMount = () => { this.getProjects(); }
	
	onChange = (e) => { this.setState({ formData: {...this.state.formData, [e.target.name]: e.target.value} }); }
	
	onDateChange = (date, name) => {
		if(date) {
			const formatedDate = moment(date).format("YYYY-MM-DD");
			this.setState({
				...this.state,
				formData: {
					...this.state.formData,
					[name]: formatedDate
				},
				selectedDate: date.toISOString(), 
			});
		}
	}

    onSelectChange = (option, name, selected) => {
    	if (option !== null) {
    		this.setState({ [selected]: option.value ,formData: {...this.state.formData, [name]: option.value || ""}});
    	} else {
    		this.setState({ [selected]:null ,formData: {...this.state.formData, [name]: null}});
    	}
    }
	
	onSubmit = (e) => {
		e.preventDefault();
		this.setState({saveFixedCostLoading: true, errors: {}});
		this.createFixedCostService.store(this.state.formData).then((res) => {
			this.setState({saveFixedCostLoading: false});
			NotificationManager.success("Fixed Cost created.","Success!");
			this.props.history.push("/fixed-costs");	 
		}).catch((err) => {
			this.setState({saveFixedCostLoading: false});
			HandleError(err, this);
		});
	}

	getProjects = () => {
		this.projectsService.index(0,"simplified=true").then((res) => {
			this.setState({isLoadingProjects: false, projects: this.mapProjectsToSelect(res.data.projects)});
		}).catch((err) => {
			this.setState({isLoadingProjects:false});
			HandleError(err,this);
		});
	}

	mapProjectsToSelect = (projects) => {
		if (projects && Array.isArray(projects)) {
			return projects.map((item) => dataToSelectOption(item.id,"value",item.name, "label"));
		}
		return [];
	}

	createFixedCostService = new FixedCostsService(this);
    projectsService = new ProjectsService(this);

    render() {
    	const { saveFixedCostLoading, formData, errors, projects, selectedDate, isLoadingProjects } = this.state;
    	return (
    		<React.Fragment>
    			<Row>
    				<form onSubmit={this.onSubmit}>
    					<Col md={4} sm={12}>
    						<span className="column-title">Fixed Cost details</span>

    						<FormGroup validationState={errors.name && "error"}>
    							<ControlLabel>Name</ControlLabel>                                  
    							<FormControl type="text" name="name" placeholder="Enter name" value={formData.name || ""} onChange={this.onChange}/>						
    							{errors.name && <InlineError text={errors.name} />}								                                							
    						</FormGroup>

    						<FormGroup validationState={errors.date && "error"}>
    							<ControlLabel>Date</ControlLabel>
    							<DatePicker
    								selected={moment(selectedDate)}
    								onChange={(e)=>this.onDateChange(e,"date")}
    								dateFormat="DD-MM-YYYY"
    								className="form-control"
    								placeholderText="Choose date"
    							/>
    							{errors.date && <InlineError text={errors.date} />}	
    						</FormGroup>	

    						<FormGroup validationState={errors.cost && "error"}>
    							<ControlLabel>Fixed Cost value</ControlLabel>                                  
    							<FormControl type="number" name="cost" placeholder="Enter cost value" value={formData.cost || ""} onChange={this.onChange}/>						
    							{errors.cost && <InlineError text={errors.cost} />}								                                							
    						</FormGroup>

    						<FormGroup validationState={errors.project_id && "error"}>
    							<ControlLabel>Project</ControlLabel>	
    							<Select
    								onChange={(option) => { this.onSelectChange(option, "project_id", "selectedProject"); }}
    								name="project_id"
    								placeholder="Select project"
    								value={formData.project_id || ""}
    								options={projects}
    								isLoading={isLoadingProjects}
    								clearable={false}
    								multi={false}											  										
    							/>
    							{errors.project_id && <InlineError text={errors.project_id} />}
    						</FormGroup>	

    						<Button className="btn-crud" bsStyle="primary" disabled={saveFixedCostLoading} type="submit">{saveFixedCostLoading?"Saving...":"Save"}</Button> 
    						{ saveFixedCostLoading ? <LoaderInline width="30" height="30" color="#2196f3"/> :  null }																												
    					</Col>	
    				</form>						
    			</Row>
    		</React.Fragment>
    	);
    }
}
FixedCostsCreateForm.propTypes = {
	history: PropTypes.shape({
		push: PropTypes.func.isRequired
	}).isRequired
};
export default FixedCostsCreateForm;


// WEBPACK FOOTER //
// ./src/components/forms/fixed-costs/FixedCostsCreateForm.js